import { render } from "./AndroidIntegrationSettings.vue?vue&type=template&id=5c5c3744"
import script from "./AndroidIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./AndroidIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__